
import { ReactElement } from "react";
import { Text } from "@chakra-ui/react";

import { StyledAvatar, StyledHeader } from "./styles";

type HeaderInfoProps = {
  Avatar: string;
  title: string | ReactElement;
  customStyle?: any;
  avatarStyle?: any;
};

const defaultStyle = {
  fontWeight: "500",
  fontSize: "1.5rem",
  letterSpacing: "0",
}

function HeaderInfo({
  Avatar,
  title,
  customStyle = defaultStyle,
  avatarStyle = {},
  ...props
}: HeaderInfoProps) {
  return (
    <StyledHeader
      avatar={
        <StyledAvatar style={avatarStyle} id="Avatar-icon-header">
          {Avatar ? (
            <Avatar />
          ) : null}
        </StyledAvatar>
      }
      title={
        <Text
          fontSize="26px"
          fontWeight="medium"
          letterSpacing="tight"
          justifyContent="center"
          color="#676C77"
          ml="2"
        >
          {title}
        </Text>
      }
    />
  );
}

export default HeaderInfo;
